var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c(
        "vxe-table",
        {
          ref: "fineTable",
          attrs: {
            "show-overflow": "",
            data: _vm.subjectList,
            height: "300px",
          },
        },
        [
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "code", title: "物料编码" },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "name", title: "物料名称" },
          }),
          _c("vxe-table-column", {
            attrs: {
              "min-width": "100",
              field: "classifyName",
              title: "物料分类",
            },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "kind", title: "具体品类" },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "spec", title: "规格型号" },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "unitName", title: "单位" },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "num", title: "数量" },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "price", title: "单价" },
          }),
          _c("vxe-table-column", {
            attrs: { "min-width": "100", field: "totalPrice", title: "总价" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }